export default __webpack_public_path__ + "static/media/neela.4ced0fe9.jpg";